import React from 'react';
import i18n from 'i18next';

import Flex, {Box} from 'components/Flex';
import Text from 'components/Text';
import HintTooltip from 'components/HintTooltip';

import Switch from 'components/Switch';

function getReadout(enabled) {
	return enabled ? i18n.t('state_enabled') : i18n.t('state_disabled');
}

function SwitchField(props) {
	const {
		description,
		disabled,
		id,
		value,
		invertUiValue,
		onChange,
		readout = getReadout,
		title,
	} = props;

	const fieldValue =
		typeof value === 'undefined' ? props.default || false : value;

	function toggleSwitch() {
		if (onChange) {
			onChange(id, !fieldValue, title);
		}
	}

	const descriptionId = description ? `${id}-desc` : null;
	const uiValue = invertUiValue ? !fieldValue : fieldValue;

	return (
		<Flex>
			<Box grow shrink pr="m">
				<Text dimmed={disabled}>
					<Text bold as="label" htmlFor={id}>
						{title}
					</Text>
					{description && (
						<HintTooltip
							content={description}
							id={descriptionId}
							spacingLeft="xxs"
						/>
					)}
					<Text display="block">{readout(uiValue)}</Text>
				</Text>
			</Box>
			<Box>
				<Switch
					id={id}
					disabled={disabled}
					checked={uiValue}
					onChange={toggleSwitch}
					aria-describedby={descriptionId}
				/>
			</Box>
		</Flex>
	);
}

export default SwitchField;
